import Base from '../../base';
import Table from './calculator-table';

class CalculatorTableCappedBonus extends Base {
	constructor(el, options) {
		super(el, options);

		this.table = new Table(this.el, this.refs, this.options);

		this.rowsBarrierReached = this.queryAll('.js-barrier-reached');
		this.rowsBarrierNotReached = this.queryAll('.js-barrier-not-reached');
	}

	update(response) {
		this.table.update(response);
		this.updateRowStates(response);
	}

	updateRowStates(response) {
		const { options } = response;

		const {
			barrierReached = false,
			barrierNeverReached = false,
		} = options;

		[...this.rowsBarrierNotReached, ...this.rowsBarrierReached].forEach(row => row.classList.remove('is-hidden'));

		if (barrierReached) {
			this.onBarrierReached();
		} else if (barrierNeverReached) {
			this.onBarrierNotReached();
		}
	}

	onBarrierReached() {
		this.rowsBarrierNotReached.forEach(row => row.classList.add('is-hidden'));
	}

	onBarrierNotReached() {
		this.rowsBarrierReached.forEach(row => row.classList.add('is-hidden'));
		this.refs.explanationBarrierNotReached.classList.add('is-hidden');
	}
}

export default CalculatorTableCappedBonus;
